import script from "./AddApiReceiverModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddApiReceiverModal.vue?vue&type=script&setup=true&lang=js"

import "./AddApiReceiverModal.vue?vue&type=style&index=0&id=747d1f1e&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-747d1f1e"]])

export default __exports__